import { css } from 'styled-components';
import { media, rem } from '../../../helpers/mixins';
import {
  PURPLE
} from '../../../constants/colors';


export default {
  wrap: css`
  margin-top:20px;
  padding-left:26px;
  padding-right:26px;
  ${media.md`
    padding-left:0px;
    padding-right:0px;
  `};
  `,
  headline: css`
  font-size: ${rem('18px')};
  margin-bottom:20px;
  display:block;
  ${media.md`
    font-size: ${rem('24px')};
    margin-bottom:30px;
  `};
  color:${PURPLE} !important;
  `,
};
